/* 🤖 this file was generated by svg-to-ts*/
export const icoTrendingDown: {
  name: 'trending-down';
  data: string;
} = {
  name: 'trending-down',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.92 17.38a1 1 0 01-.54.54.999.999 0 01-.38.08h-4.998a1 1 0 110-1.999h2.589l-5.588-5.587-3.29 3.298a1 1 0 01-1.419 0L2.296 7.715a1 1 0 010-1.42 1 1 0 011.42 0l5.288 5.298 3.289-3.298a1 1 0 011.42 0L20 14.592v-2.59a1 1 0 011.999 0V17a1 1 0 01-.08.38z" fill="#909090"/></svg>`
};
